import BaseResource from '@/lib/data/resource/BaseResource'

export default class MemberResource extends BaseResource {
  constructor (payload = {}) {
    super(payload)

    this.Id = payload.Id ?? null
    this.Uid = payload.Uid ?? null
    this.Corps = payload.Corps ?? ''
    this.CompanyId = payload.CompanyId ?? null
    this.CompanyName = payload.CompanyName ?? null
    this.FirstName = payload.FirstName ?? ''
    this.LastName = payload.LastName ?? ''
    this.FathersName = payload.FathersName ?? ''
    this.Phone = payload.Phone ?? ''
    this.Email = payload.Email ?? ''
    this.Active = payload.Active ?? false
    this.CreatedAt = payload.CreatedAt ?? ''
  }

  /* PROPERTIES */

  /* METHODS */
}
